<template>
  <div name="hres6oe-work-place" class="checkin-google-map -with-bg">
    <div class="alert alert-last-checkin animated fadeIn" v-show="lastCheckIn.dtework !== ''">
      <div class="alert-content">
        <div class="header clearfix" @click="toggleNotiDetail()">
          <i class="icon fa fa-map-marker"></i>
          <div class="title">
            {{ lastCheckIn.flg_inout === 'I' ? 'LAST CHECK IN TIME' : 'LAST CHECK OUT TIME' }}
          </div>
          <div class="time">
            <i class="fa fa-clock-o" aria-hidden="true"></i>
            {{ lastCheckIn.flg_inout === 'I' ? setDateOutput(lastCheckIn.dtein) + ' ' + lastCheckIn.timin : setDateOutput(lastCheckIn.dteout) + ' ' + lastCheckIn.timout }}
          </div>
        </div>
        <div class="body clearfix" v-show="dispNotiDetail">
          <div class="place">{{ lastCheckIn.namcust }}</div>
          <div class="description">{{ lastCheckIn.address }}</div>
        </div>
      </div>
    </div>
    <div class="nearby-location animated fadeIn">
      <div v-show="flgIsCheckin">
        <div class="search-place" :class="[dispNearByDropdown ? 'open-dropdown' : '']" @click="toggleNearByDropdown()">
          <div class="color-icon -no-border">
            <i class="fa fa-map-marker -icon-building _text-red"></i>
          </div>
          <div class="building-detail">
            <div class="building-name">
              {{label['HRES6OEC1']['40']}}
            </div>
          </div>
          <i class="fa icon-select" :class="[dispNearByDropdown ? 'fa-angle-up' : 'fa-angle-down']" aria-hidden="true"></i>
        </div>
        <div class="nearby-place-box" v-show="dispNearByDropdown && nearByDropdownLoading">
          <div class="select-place align-center">
            <div class="infinite-loading-container"><i class="loading-wave-dots"></i></div>
          </div>
        </div>
        <div id="nearby-place-box" class="nearby-place-box" v-if="dispNearByDropdown && !nearByDropdownLoading">
          <div class="select-place" v-for="(place, placeIndex) in workPlace" :key="placeIndex" @click="callCheckIn(placeIndex)">
            <div class="color-icon -no-border">
              <i class="fa fa-building -icon-building"></i>
            </div>
            <div class="building-detail">
              <div class="building-name">
                {{ place.codcust }} {{ place.namcust }}
              </div>
              <div class="building-location">
                {{ place.address }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="coordinates-box animated fadeIn">
      <div class="row">
        <div class="col-xs-2 col-ms-4 col-sm-4 align-center">
          <i class="ion-navigate arrow-icon fa-3x cursor-pointer" @click="callLocation()" aria-hidden="true"></i>
        </div>
        <div class="col-xs-10 col-ms-8 col-sm-8">
          <div class="coordinatesdetail-group">
            <div class="detail-box">
              <div class="label-box">
                <div>{{label['HRES6OEC1']['10']}} :</div>
                <div>{{label['HRES6OEC1']['20']}} :</div>
              </div>
              <div class="data-box">
                <div>{{center.lat}}</div>
                <div>{{center.lng}}</div>
              </div>
              <div class="detail-small">In a radius of no more than {{ center.accuracy }} km.</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="map-panelmenu">
      <div class="menu-box" @click="callHistory()">
        <i class="fa fa-clock-o _text-blue" aria-hidden="true"></i>History
      </div>
      <div class="menu-box" :class="center.lat === 0 ? '_text-grey' : ''" @click="callCheckIn(-1)">
        <i class="ion-ios-location" :class="center.lat === 0 ? '_text-grey' : '_text-red'" aria-hidden="true"></i><span v-show="flgIsCheckin">Check In</span><span v-show="!flgIsCheckin">Check Out</span>
      </div>
    </div>
  </div>
</template>

<script>
import env from 'src/../env.js'
import swal from 'sweetalert'
import { constLabels } from 'assets/js/constLabels.js'
import assetsUtils from 'assets/js/utils'

export default {
  name: 'hres6oe-work-place',
  props: [
    'label',
    'workPlace',
    'toggle',
    'startFlgLoading',
    'stopFlgLoading',
    'flgCheckin',
    'lastCheckIn',
    'center',
    'app',
    'setPathImage',
    'receivedCheckInHistory',
    'receivedCheckInPlace',
    'receivedDataInRaius',
    'dataInRadius',
    'getMeLocation',
    'stopInterval',
    'scrollTop',
    'saveCheckInLog',
    'clearFilterLocation',
    'selectedCompanyCheckin',
    'setSelectedCompanyCheckin'
  ],
  data () {
    return {
      baseURL: window.localStorage.getItem(env.site + '_baseURL'),
      pathImage: '',
      dispNotiDetail: true,
      dispNearBy: true,
      dispNearByDropdown: false,
      nearByDropdownLoading: false,
      tmpSelectedCompanyCheckin: -2
    }
  },
  computed: {
    flgIsCheckin () {
      if (this.lastCheckIn.flg_inout === '' || this.lastCheckIn.o_dtework === 'undefined' || this.tmpSelectedCompanyCheckin === -2) {
        return false
      }
      return !(this.lastCheckIn.flg_inout === 'I' && this.tmpSelectedCompanyCheckin >= 0 && this.lastCheckIn.o_dtework === 'N')
    }
  },
  watch: {
    workPlace () {
      this.nearByDropdownLoading = false
      this.checkLastCheckinInArea()
      if (this.workPlace.length === 0) {
        this.dispNearByDropdown = false
      }
    }
  },
  methods: {
    setDateOutput (date) {
      return assetsUtils.getDateOutput(date)
    },
    callCheckIn (placeIndex) {
      let userAgent = navigator.userAgent.toLowerCase()
      if (userAgent.search('line') !== -1) {
        swal({title: '', text: constLabels('notSupportLineBrowser'), html: true, type: 'warning'})
      } else if (userAgent.search('windows') !== -1) {
        swal({title: '', text: constLabels('notSupportPc'), html: true, type: 'warning'})
      } else if (userAgent.search('macintosh') !== -1) {
        swal({title: '', text: constLabels('notSupportPc'), html: true, type: 'warning'})
      } else {
        this.setSelectedCompanyCheckin(placeIndex)
        this.scrollTop()
        this.clearFilterLocation()
        this.getMeLocation()
        this.dispNearByDropdown = false
        if (this.center.lat !== 0) {
          this.setupDir()
          this.toggle('detail')
        } else {
          swal({
            title: constLabels('warningTitle'),
            text: constLabels('HR9001'),
            confirmButtonText: constLabels('ok')
          })
        }
        let logMsg = this.center.lat + ', ' + this.center.lng + '\tLast checkin: ' + this.lastCheckIn.dtework + ' [' + this.lastCheckIn.flg_inout + '] ' + this.lastCheckIn.codcust
        this.saveCheckInLog({params: {filename: 'hres6oe-log', text: logMsg}})
      }
    },
    callHistory () {
      this.scrollTop()
      this.receivedCheckInHistory(this.app.currentUser.p_codempid)
      this.toggle('history')
      this.setupDir()
    },
    setupDir () {
      this.pathImage = this.baseURL + 'file_uploads/' + this.app.$children[0].getTfolder().folder + '/'
      this.setPathImage(this.pathImage)
    },
    toggleNearByDropdown () {
      this.dispNearByDropdown = !this.dispNearByDropdown
      if (this.dispNearByDropdown) {
        this.nearByDropdownLoading = true
        this.receivedCheckInPlace(this.center)
        this.stopFlgLoading()
      }
    },
    toggleNotiDetail () {
      this.dispNotiDetail = !this.dispNotiDetail
    },
    checkLastCheckinInArea () {
      this.tmpSelectedCompanyCheckin = this.workPlace.map(dataMap => {
        return dataMap.codcust
      }).indexOf(this.lastCheckIn.codcust)
    },
    callLocation () {
      this.getMeLocation()
      // this.startFlgLoading()
    }
  }
}
</script>



// WEBPACK FOOTER //
// workPlace.vue?e764ca22